"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetAdapterAvailableProps = exports.ModifyEditorState = exports.AdapterModifier = exports.publicOnSave = exports.localOnChangeState = exports.localGetEditorState = exports.getLocalCache = exports.setReduxCache = void 0;

var _core = require("@widget-editor/core");

var localCache = {};
var REDUX_CACHE_DISPATCH = null;

var setReduxCache = function setReduxCache(dispatch) {
  REDUX_CACHE_DISPATCH = dispatch;
};

exports.setReduxCache = setReduxCache;

var getLocalCache = function getLocalCache() {
  return localCache;
};

exports.getLocalCache = getLocalCache;

var localGetEditorState = function localGetEditorState(payload) {
  localCache = _objectSpread({}, localCache, {}, payload);
};

exports.localGetEditorState = localGetEditorState;

var localOnChangeState = function localOnChangeState(editorState) {
  if (localCache.adapter && !!editorState.editor.dataset) {
    var outputPayload = (0, _core.getOutputPayload)(editorState, localCache.adapter);
    localCache = _objectSpread({}, localCache, {
      outputPayload: outputPayload,
      editorState: editorState
    });
  }
};

exports.localOnChangeState = localOnChangeState;

var publicOnSave = function publicOnSave() {
  return {
    payload: localCache.outputPayload,
    editorState: localCache.editorState
  };
};

exports.publicOnSave = publicOnSave;

var AdapterModifier = function AdapterModifier(Adapter, props) {
  var ClonedAdapter =
  /*#__PURE__*/
  function (_Adapter) {
    _inherits(ClonedAdapter, _Adapter);

    function ClonedAdapter() {
      var _this;

      _classCallCheck(this, ClonedAdapter);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(ClonedAdapter).call(this));

      _this.extendProperties(props);

      return _this;
    }

    return ClonedAdapter;
  }(Adapter);

  return ClonedAdapter;
};

exports.AdapterModifier = AdapterModifier;

var ModifyEditorState = function ModifyEditorState(props) {
  if (!REDUX_CACHE_DISPATCH) {
    throw new Error('Widget editor: ModifyEditorState hook error, We dont have access to redux dispatch.');
  }

  if (_typeof(props) === 'object') {
    REDUX_CACHE_DISPATCH({
      type: _core.constants.reduxActions.EDITOR_SET_CONFIGURATION,
      payload: props
    });
  } else {
    throw new Error('Widget editor: ModifyEditorState hook error, props needs to be typeof object.');
  }
};

exports.ModifyEditorState = ModifyEditorState;

var GetAdapterAvailableProps = function GetAdapterAvailableProps(Adapter) {
  var instance = new Adapter();
  var availableProps = Object.keys(instance).map(function (prop) {
    return {
      name: prop,
      type: _typeof(instance[prop])
    };
  });
  console.log("Adapter available properties:");
  console.table(availableProps);
};

exports.GetAdapterAvailableProps = GetAdapterAvailableProps;